/** The resend composition's own replacement warning ("Link sent, one screen" board, settled
 *  2026-09-17), shared verbatim by every route's resend composition (LinkSentResend and
 *  LinkSentSignInResend both take it as their own replacementWarning) and by both apps'
 *  index.tsx. Exported standalone so every caller shares one string. */
export const LINK_REPLACEMENT_WARNING =
  'A new link replaces the old one. The old link cannot be used.';

/** The "repeat routes" task's own fourth ResendReserve occupant (settled 2026-09-18), answering a
 *  customer who pressed the resend link inside the 60 second window once that window has since
 *  elapsed. Opens with the news that a press now works, then reuses LINK_REPLACEMENT_WARNING by
 *  reference so the screen can never carry two different wordings of the one fact. Exported
 *  standalone for the same reason as LINK_REPLACEMENT_WARNING above. */
export const RESEND_NOW_MESSAGE = `You can resend now. ${LINK_REPLACEMENT_WARNING}`;

/** The "Link sent, one screen" design board's tail line under the expiry panel, shared by every
 *  screen that composes LinkSent (SignInLinkRequested, GoogleSsoSignUpForm and RecoverInvitation
 *  all pass it verbatim). Edited from the Figma product file's own wording: "for the email" came
 *  off, for the same reason the lead line drops it - the customer receives one thing and acts on
 *  one thing. Curly apostrophe in "it's", matching the board's own text exactly. */
export const LINK_SENT_TAIL =
  'Please check your inbox and follow the steps. If it’s not there, check your junk/spam ' +
  'folder. You can safely close this tab now.';
